import $http from "../../api/api.js";
import $public from "../../util/public.js";
import { getallMemberCanUseCoupon } from "@/api/newCoupon.js";
export default {
  namespaced: true,
  state: {
    router: [],
    platformParams: {
      type: "list",
      navIndex: 0,
      medicalCount: {},
      initialDataOflist: {},
      initialDataOflist1: {},
    },
    guahaoParams: {
      type: "add",
    },
    jiezhenParams: {
      type: "list",
      curPage: 1,
      curRow: {},
      initialDataOflist: {},
    },
    ymqcParams: {
      type: "list",
      curPage: 1,
      curRow: {},
      initialDataOflist: {},
    },
    ylfwParams: {
      type: "list",
      curPage: 1,
      curRow: {},
      curRow_package: {},
      initialDataOflist: {},
    },
    bingliParams: {
      type: "list",
      curPage: 1,
      curRow: {},
      initialDataOflist: {},
    },
    zhuyuanParams: {
      type: "list",
      curPage: 1,
      curRow: {},
      initialDataOflist: {},
    },
    yaofangParams: {
      type: "list",
      tabIndex: 1,
      curRow: {},
      // initialDataOflist:{}, // 没有这个
      initialDataOflist_bingli: {},
      initialDataOflist_ymqc: {},
      initialDataOflist_ylfw: {},
    },
    rightBingliParams: {
      type: "list",
      num: 0,
      initialDataOflist: {},
    },
    rightYmqcParams: {
      type: "list",
      num: 0,
      initialDataOflist: {},
    },
    rightZhuyuanParams: {
      type: "list",
      num: 0,
      initialDataOflist: {},
    },
    rightWaitRegistrationParams: {
      type: "list",
      num: 0,
      initialDataOflist: {},
    },
    rightInRegistrationParams: {
      type: "list",
      num: 0,
      initialDataOflist: {},
    },
    ///////////////////////////////////////////
    userController: [],
    userInfo: {},
    danganNumber: "",
    curPetId: "",
    curBusiness: "工作台",
    curBusinessPre: "",
    // 可用优惠券列表  医疗服务
    couponList: [],
  },
  getters: {
    curPetInfo(state) {
      if (
        state.userInfo.pets_info &&
        state.userInfo.pets_info[0] &&
        state.curPetId
      ) {
        return (
          state.userInfo.pets_info.filter((item) => {
            return item._id == state.curPetId;
          })[0] || {
            weight_records: [],
            apply_type: {},
            category_info: {},
            create_info: {},
            status: {},
          }
        );
      } else {
        return {
          weight_records: [],
          apply_type: {},
          category_info: {},
          create_info: {},
          status: {},
        };
      }
    },
    canChangeCurMember(state) {
      let b = true;
      if (
        state.curBusiness === "病例" &&
        (state.bingliParams.type === "see" ||
          state.bingliParams.type === "edit")
      ) {
        b = false;
      } else if (
        state.curBusiness === "疫苗驱虫" &&
        (state.ymqcParams.type === "see" || state.ymqcParams.type === "edit")
      ) {
        b = false;
      } else if (
        state.curBusiness === "医疗服务" &&
        (state.ylfwParams.type === "see" || state.ylfwParams.type === "edit")
      ) {
        b = false;
      }
      return b;
    },
  },
  mutations: {
    add_router(state, obj) {
      state.router.push(JSON.parse(JSON.stringify(obj)));
    },
    replace_router(state, obj) {
      console.log(obj);
      if (state.router.length === 0) {
        console.log("router===0");
        state.router.push(JSON.parse(JSON.stringify(obj)));
      } else {
        state.router.pop();
        state.router.push(JSON.parse(JSON.stringify(obj)));
      }
    },
    remove_router(state) {
      if (state.router.length === 0) {
        console.log("router===0");
      } else if (state.router.length === 1) {
        console.log("router===1");
      } else if (state.router.length > 1) {
        state.router.pop();
        let r = state.router.slice(-1)[0];
        state.curBusiness = r.name;
        if (r.name === "工作台") {
          state.platformParams = r.data;
        } else if (r.name === "接诊") {
          state.jiezhenParams = r.data;
        } else if (r.name === "病例") {
          state.bingliParams = r.data;
        } else if (r.name === "疫苗驱虫") {
          state.ymqcParams = r.data;
        } else if (r.name === "医疗服务") {
          state.ylfwParams = r.data;
        } else if (r.name === "住院") {
          state.zhuyuanParams = r.data;
        } else if (r.name === "药房") {
          state.yaofangParams = r.data;
        }
      }
    },
    //医疗服务可用优惠券
    set_couponList(state, obj) {
      state.couponList = obj;
    },
    set_platformParams(state, obj) {
      state.platformParams = obj;
    },
    set_guahaoParams(state, obj) {
      state.guahaoParams = obj;
    },
    set_jiezhenParams(state, obj) {
      state.jiezhenParams = obj;
    },
    set_ymqcParams(state, obj) {
      state.ymqcParams = obj;
    },
    set_ylfwParams(state, obj) {
      state.ylfwParams = obj;
    },
    set_bingliParams(state, obj) {
      state.bingliParams = obj;
    },
    set_zhuyuanParams(state, obj) {
      state.zhuyuanParams = obj;
    },
    set_yaofangParams(state, obj) {
      state.yaofangParams = obj;
    },
    ///////////////////////////////////////////
    set_userController(state, obj) {
      state.userController = obj;
    },
    set_userInfo(state, obj) {
      if ($public.isNull(obj.pets_info)) {
        state.curPetId = "";
      } else {
        state.curPetId = obj.pets_info[0]._id;
      }
      state.userInfo = obj;
    },
    set_danganNumber(state, obj) {
      state.danganNumber = obj;
    },
    set_curPetId(state, obj) {
      state.curPetId = obj;
      state.danganNumber = "";
    },
    set_curBusiness(state, obj) {
      if (
        obj === "工作台" ||
        obj === "挂号" ||
        obj === "接诊" ||
        obj === "病例" ||
        obj === "疫苗驱虫" ||
        obj === "医疗服务" ||
        obj === "住院" ||
        obj === "药房"
      ) {
        state.curBusinessPre = obj;
      } else {
        state.curBusinessPre = state.curBusiness;
      }
      state.curBusiness = obj;
    },
    set_rightBingliParams(state, obj) {
      state.rightBingliParams = obj;
    },
    set_rightYmqcParams(state, obj) {
      state.rightYmqcParams = obj;
    },
    set_rightZhuyuanParams(state, obj) {
      state.rightZhuyuanParams = obj;
    },
    set_rightWaitRegistrationParams(state, obj) {
      state.rightWaitRegistrationParams = obj;
    },
    set_rightInRegistrationParams(state, obj) {
      state.rightInRegistrationParams = obj;
    },
  },
  actions: {
    // getUserInfo({commit},id){
    // 	$http.get('/api/Member/Single', {"id": id}).then(res => {
    // 		if(res.code==0){
    // 			commit('set_userInfo',res.data)
    // 			// if($public.isNull(res.data.pets_info)){
    // 			// 	commit('set_curPetId','')
    // 			// }else{
    // 			// 	commit('set_curPetId',res.data.pets_info[0]._id)
    // 			// }
    // 			// // 获取会员权益数量
    // 			// let num = 0;
    // 			// for(let i=0;i<res.data.pets_info.length;i++){
    // 			// 	let petItem = res.data.pets_info[i];
    // 			// 	if(petItem.medical_money&&petItem.medical_money.status===1){
    // 			// 		num++;
    // 			// 	}
    // 			// 	if(petItem.hundred_assure&&petItem.hundred_assure.status===1){
    // 			// 		num++;
    // 			// 	}
    // 			// }
    // 			// commit('set_huiyuanquanyiNum',num)
    // 		}
    // 	})
    // },
    get_couponList({ commit }, id) {
      let params = {
        member_id: id,
        activity_type: 3,
        use_status: 1,
        apply_type: 5,
        use_scene: 2, //使用场景 0 全部 1线上 2线下
      };
      getallMemberCanUseCoupon(params).then(res => {
        if (res.code == 0) {
          // console.log(res,'可用优惠券');
          commit('set_couponList', res.data.data)
        }
      })
    },
    get_danganNumber({ commit }, id) {
      let params = {
        petId: id,
      };
      $http.get("/api/Registration/ArchivesCode", params).then((res) => {
        if (res.code == 0) {
          commit("set_danganNumber", res.data);
        }
      });
    },
    get_medicalCount({ state, commit }, id) {
      let params = {
        memberId: id,
      };
      $http.get("/api/Platform/MedicalCount", params).then((res) => {
        if (res.code == 0) {
          state.platformParams.medicalCount = res.data;
          commit("set_platformParams", state.platformParams);
        }
      });
    },
    get_NotMedicalCount({ state, commit }) {
      $http.get("/api/Platform/NotMedicalCount", {}).then((res) => {
        if (res.code == 0) {
          // 病例
          state.rightBingliParams.num = res.data.notCaseCount;
          commit("set_rightBingliParams", state.rightBingliParams);
          // 疫苗驱虫
          state.rightYmqcParams.num = res.data.notPackageCount;
          commit("set_rightYmqcParams", state.rightYmqcParams);
          // 住院
          state.rightZhuyuanParams.num = res.data.inInhospitalCount;
          commit("set_rightZhuyuanParams", state.rightZhuyuanParams);
          // 待接诊
          state.rightWaitRegistrationParams.num =
            res.data.waitRegistrationCount;
          commit(
            "set_rightWaitRegistrationParams",
            state.rightWaitRegistrationParams
          );
          // 诊疗中
          state.rightInRegistrationParams.num = res.data.inRegistrationCount;
          commit(
            "set_rightInRegistrationParams",
            state.rightInRegistrationParams
          );
        }
      });
    },
  },
};
